var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewsTopSwirlinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 75,
    viewBox: "5 5 390 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-.008.075L-.003 25.7C30.34 34.98 184.145 50.12 255.49 23.387c57.742-21.634 121.292-13.065 139.462-2.557l.014-20.966",
    fill: "#f7f0eb"
  })));
}
export default SvgReviewsTopSwirlinline;